import React from 'react';
import ReactExport from 'react-data-export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const isMultiSheetDataSet = multiDataSet =>
  Array.isArray(multiDataSet) &&
  multiDataSet.length > 0 &&
  multiDataSet.every(item => item && typeof item === 'object' && Array.isArray(item.dataSet));

const ExcelExport = ({ element, multiDataSet, nameSheet, fileName }) => {
  if (isMultiSheetDataSet(multiDataSet)) {
    return (
      <ExcelFile element={element} filename={fileName || ''}>
        {multiDataSet.map((sheet, index) => (
          <ExcelSheet key={`${sheet.name || nameSheet || 'sheet'}_${index + 1}`} dataSet={sheet.dataSet} name={sheet.name || `${nameSheet || 'Sheet'}_${index + 1}`} />
        ))}
      </ExcelFile>
    );
  }

  return (
    <ExcelFile element={element} filename={fileName || ''}>
      <ExcelSheet dataSet={multiDataSet} name={nameSheet || ''} />
    </ExcelFile>
  );
};

export default ExcelExport;
